import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './style/LoadingOnePager.css'
import Loading from '../loading/Loading'; // Your existing loading spinner component

const LoadingOnePager: React.FC = () => {
    const { ID } = useParams<{ ID: string }>();
    const [error, setError] = useState<string | null>(null);

    const calendarURL = process.env.REACT_APP_CALENDAR_API_URL;

    useEffect(() => {
        if (!calendarURL) {
            setError('Calendar API URL is not defined');
            return;
        }

        if (!ID) {
            setError('Missing ID parameter in URL');
            return;
        }

        // Redirect to the backend endpoint to generate/download the PDF
        window.location.href = `${calendarURL}generateOnePager/${ID}/`;
    }, [ID, calendarURL]);

    return (
        <div className="one-pager-loader">
            <h2 className="loading-title">Preparing your meeting one-pager...</h2>
            {error && <p className="error-message">{error}</p>}
            <Loading />
        </div>
    );
};

export default LoadingOnePager;
